import SplashScreen from "@/components/splash-screen";
import { useFetchOnboardingStatus } from "@/hooks/use-organisation";
import { usePermission } from "@/hooks/use-premission";
import {
  useGetActiveSubscriptionPlans,
  useGetUsage,
} from "@/hooks/use-subscription";
import { useFetchMembers } from "@/stores/members.store";
import { useActiveTenancy } from "@wacht/tanstack-router";
import React, { useEffect, useState } from "react";

const AppInitializer: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  // Subscription related apis
  const {
    isLoading: isActiveSubscriptionPlansLoading,
    error: subscriptionError,
  } = useGetActiveSubscriptionPlans();
  const { isLoading: isUsageLoading, error: usageError } = useGetUsage();

  // Onboarding status
  const onboardingStatusQuery = useFetchOnboardingStatus();

  const { isLoading: isPermissionLoading } = usePermission();
  const { fetchMembers } = useFetchMembers();
  const { orgMembership } = useActiveTenancy();

  const [isMembersIsInProcess, setIsMembersIsInProcess] = useState(true);

  useEffect(() => {
    const fetchClerkMembers = () => {
      if (orgMembership?.organization?.id && !isMembersIsInProcess) {
        fetchMembers().finally(() => setIsMembersIsInProcess(false));
      }
    };
    fetchClerkMembers();
  }, [orgMembership?.organization?.id]);

  // Check if we have network errors (backend not available)
  const hasNetworkError = subscriptionError || usageError;

  // If we have network errors, skip loading and render children
  if (hasNetworkError) {
    console.warn("Backend not available, skipping initialization:", {
      subscriptionError,
      usageError,
    });
    return children;
  }

  if (
    isActiveSubscriptionPlansLoading ||
    isPermissionLoading ||
    isUsageLoading
  ) {
    return <SplashScreen showInitialAnimation={false} />;
  }

  return children;
};

export default AppInitializer;
